module.exports = __webpack_public_path__ + "static/media/sitedirectores.c5ab33f8.png";